import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-marketing-scholarships',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (items.length) {
      <div class="grid gap-4">
        @for (s of items; track s.name) {
          <article class="cg-mkt-card cg-mkt-scholar">
            <h3 class="m-0 font-semibold">{{ s.name }}</h3>
            @if (s.provider) {
              <p class="mt-1 text-sm text-slate-500">{{ s.provider }}</p>
            }
            @if (s.summary) {
              <p class="mt-2 text-sm text-slate-700">{{ s.summary }}</p>
            }
            @if (s.ctaUrl) {
              <a class="mt-2 inline-block text-sm font-semibold text-orange-600" [href]="s.ctaUrl" target="_blank" rel="noopener noreferrer">Details</a>
            }
          </article>
        }
      </div>
    }
  `,
})
export class MarketingScholarshipsComponent {
  @Input() items: Array<{ name: string; provider?: string; summary?: string; ctaUrl?: string }> = [];
}
